export default {
  banner: {
    title: "Authing Partner Network",
    subtitle:
      "We have found a way to help enterprise administrators and developers to complete application single sign-on more simply and efficiently.",
    "label-one": "User authentication",
    "label-two": "Distribution countries",
    "label-three": "Customer service",
    "label-four": "Service time",
  },
  contents: {
    item1: "Integrate third-party apps in two steps",
    item2: "Safe and open, Easy to search",
    item3: "The integration steps",
    item4: "Partner spotlight",
  },
  "application-list": {
    item1: {
      title: "Integrate third-party apps in two steps",
      descript1:
        "1. Find the application you want to integrate in the Authing Partner Network.",
      descript2: `2. Click "Get Application" to fill in the relevant configuration of the application.`,
    },
    item2: {
      title: "Safe and open, Easy to search",
      subtitle:
        "We provide a directory of trusted partners and third-party integrated applications. You can add third-party applications to your Authing console with just a few clicks.",
      card1: {
        title: "Trustworthy",
        descript:
          "Authing provides a variety of safe and effective authorization methods, and all applications on the shelves have passed Authing's strict security certification.",
      },
      card2: {
        title: "Easy to search",
        descript:
          "You can not only easily find the integrated applications you need, but also browse the integrated applications you don't know about in the Authing Partner Network.",
      },
      card3: {
        title: "Open and self-service",
        descript:
          "Authing provides an open and self-service partner network, so that developers can exchange resources in this Authing Partner Network.",
      },
    },
    item3: {
      title: "The integration steps",
      descript1: `Let us illustrate how to use the partner network by integrating "Tencent Cloud". Your users will quickly log in to your application through their Tencent Cloud account. First of all, if you do not have a free Authing account, please register one first.`,
      descript2: `After entering the Authing console, go to the application marketplace. Here, you can choose application integration based on your needs. Here, let’s search for "Tencent" first`,
      descript3: `Click on the first option "Tencent Cloud".`,
      descript4:
        "This will take you to the Tencent Cloud integration page, which contains the following information:",
      "descript4-list1": "Description of third-party integrated applications",
      "descript4-list2":
        "Third-party integrated application address and privacy policy",
      "descript4-list3": `"Get Application" button, it will take you to the application installation integration configuration page.`,
      descript5: `Click the "Access Tutorial" button and you will see a detailed step-by-step description of the integrated application configuration.`,
      descript6: `After completing the configuration of "Tencent Cloud" according to the help document, click "Save". You will be directed to the Authing application list page to assign permissions to users. To test whether it works, select "Experience Login".`,
      descript7: `If the link works normally, you will see a page containing the user's personal information in the "Tencent Cloud Console".`,
      descript8:
        "It's that simple! To sum up, the Authing Partner Network can help you:",
      "descript8-list1":
        "Search for the target application and reach the target in one step",
      "descript8-list2":
        "Self-service tutorials to help you get started quickly",
      "descript8-list3": "Open mode, borderless experience",
    },
    item4: {
      title: "Partner spotlight",
    },
  },
};
